import {Col, Row} from 'antd';
import {useFormikContext} from 'formik';
import {Input} from 'formik-antd';
import {useIntl} from 'react-intl';
import FormItem from 'src/shared/components/form-item';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';

interface IRejectionReasonsLanguageProps {
  code: string;
  index: number;
}

const RejectionReasonsLanguage = (props: IRejectionReasonsLanguageProps) => {
  const {code} = props;

  const {messages} = useIntl();

  const {setFieldValue, values} = useFormikContext<any>();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name={'name'}
            label={messages['common.reason'].toString()}
            fieldCommponent={
              <Input
                name={'name'}
                value={getLocaleValue(values?.locales, code, 'name')}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    code,
                    'name',
                    value.target.value,
                  )
                }
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default RejectionReasonsLanguage;
